<template>
  <div>
    <h1 v-if="currentCategory?.contextSensitiveData?.name && !isMainCategory" class="category_heading">
      {{ currentCategory?.contextSensitiveData?.name }}
    </h1>
    <BasicBtErrorBoundary>
      <SearchCategoryBanner
        v-if="!appConfig?.isAppUser"
        :category-id="currentCategory?.categoryId"
      />
    </BasicBtErrorBoundary>
    <BasicBtErrorBoundary>
      <div
        v-if="zoovuuFeatureState"
        class="zoovuuScript px-8"
      >
        <ContentZoovuuScript :current-category="currentCategory" />
      </div>
    </BasicBtErrorBoundary>
    <template v-if="currentCategory?.contextSensitiveData?.seoContent1">
      <div
        class="seo_content_1 p-4"
        v-html="currentCategory?.contextSensitiveData?.seoContent1"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import type { NeoArticleCategoryView } from '@expert/types';

interface Props {
  currentCategory: NeoArticleCategoryView;
}

const props = defineProps<Props>();
const appConfig = useAppConfig();
const zoovuuFeatureState = useFeatureState('ES-4621');

const route = useRoute();

const isMainCategory = computed(() => {
	return props.currentCategory?.mainParentId === null;
});
</script>
